import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Input, Modal, notification, Popconfirm, Row } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styles from './modal.module.css'
import {
  PlusOutlined,
  MinusOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from '@ant-design/icons'
import { RootDispatch } from '../../../../app/store'
import { deletePatientOptionsAsync, getPatientOptionsAsync, savePatientOptionsAsync } from '../toothHomeSlice'

export const SettingOptionsModal = (props: {
  visible: boolean
  type: string
  onOk: () => void
  onCancel: () => void
  // onDelete: (id: number) => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const [classificationList, setClassificationList] = useState<any>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const text = props.type === '0' 
  ? '号码归属人' : props.type === '1'
  ? '患者来源' : props.type === '2'
  ? '就诊项目' : ''

  const moveItemUp = (index: number) => {
    const newClassificationList = [...classificationList];
    const temp = newClassificationList[index];
    newClassificationList[index] = newClassificationList[index - 1];
    newClassificationList[index - 1] = temp;
    setClassificationList(newClassificationList);
  };
  
  const moveItemDown = (index: number) => {
    const newClassificationList = [...classificationList];
    const temp = newClassificationList[index];
    newClassificationList[index] = newClassificationList[index + 1];
    newClassificationList[index + 1] = temp;
    setClassificationList(newClassificationList);
  };

  useEffect(() => {
    if (!props.visible) return
    dispatch(getPatientOptionsAsync({ types: props.type }))
    .then(unwrapResult)
    .then((res: any) => {
      setClassificationList(res ? res?.find((t: any) => t.type == props.type)?.items?.map((v: any) => {
        return {
          name: v.context,
          id: v.id
        }
      })?.concat([
        {
          name: '',
          id: '',
        },
      ]) : [
        {
          name: '',
          id: '',
        },
      ])
    })
  }, [props.visible])

  return (
    <div>
      <Modal
        width={640}
        // wrapClassName={styles.modalWrap}
        title={`${text}设置`}
        visible={props.visible}
        okText='保存'
        confirmLoading={confirmLoading}
        onOk={() => {
          if (classificationList.some((v: any) => v.name == '全部')) {
            notification.info({ message: '名称不能设置成全部' })
            return
          }
          setConfirmLoading(true)
          const tempArr = classificationList.filter((item: any) => {
            return item.name != ''
          })?.map((t: any, index: number) => {
            return {
              context: t.name,
              id: t.id,
              sortNo: index + 1
            }
          })
          dispatch(savePatientOptionsAsync({type: props.type, items: tempArr}))
          .then(unwrapResult)
          .then(() => {
            setConfirmLoading(false)
            notification.success({ message: '操作成功' })
            props.onOk()
          })
          .finally(() => { setConfirmLoading(false) })
        }}
        onCancel={() => props.onCancel()}
      >
        {classificationList &&
          classificationList.map((item: any, index: number) => {
            return (
              <Row key={index}>
                <Col
                  span={18}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Input
                    value={item.name}
                    maxLength={6}
                    onChange={(e) => {
                      const values = e.target.value
                      const data = classificationList.map(
                        (v: any, num: number) => {
                          if (v.id == item.id && num == index) {
                            return {
                              ...v,
                              name: values,
                            }
                          } else {
                            return v
                          }
                        }
                      )

                      if (data[data.length - 1].name != "") {
                        //判断是否新增一行
                        data.push({
                          name: "",
                          id: "",
                        })
                      }
                      setClassificationList(data)
                    }}
                  />
                  <Popconfirm
                    placement='top'
                    title={'确认删除该类型吗？'}
                    onConfirm={() => {
                      let data
                      if (item.id == '') {
                        data = classificationList.filter(
                          (v: any, num: number) => {
                            return num !== index
                          }
                        )
                        notification.success({ message: '删除成功' })
                        setClassificationList(data)
                      } 
                      else {
                        dispatch(deletePatientOptionsAsync(item.id))
                          .then(unwrapResult)
                          .then((res) => {
                            data = classificationList.filter(
                              (v: any, num: number) => {
                                return item.id !== v.id
                              }
                            )
                            notification.success({ message: '删除成功' })
                            setClassificationList(data)
                          })
                      }
                    }}
                    okText='确认'
                    cancelText='取消'
                  >
                    <div className={styles.iptClose}>
                      <MinusOutlined
                        style={{ marginLeft: '10px', color: '#101010' }}
                      />
                    </div>
                  </Popconfirm>
                </Col>
                {item.name && (
                  <Col
                    span={6}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-10px",
                    }}
                  >
                    {index != 0 ? (
                      <Button
                        type="primary"
                        size="small"
                        style={{ width: "66px", marginLeft: "10px" }}
                        onClick={() => moveItemUp(index)}
                      >
                        <ArrowUpOutlined style={{ color: "#ffffff" }} />
                        上移
                      </Button>
                    ) : (
                      <div style={{ width: "66px", marginLeft: "10px" }}></div>
                    )}
                    {classificationList?.filter((v: any) => v?.name)?.length -
                      1 ==
                    index ? (
                      <div style={{ width: "66px", marginLeft: "10px" }}></div>
                    ) : (
                      <Button
                        type="primary"
                        size="small"
                        style={{ width: "66px", marginLeft: "10px" }}
                        onClick={() => moveItemDown(index)}
                      >
                        <ArrowDownOutlined style={{ color: "#ffffff" }} />
                        下移
                      </Button>
                    )}
                  </Col>
                )}
              </Row>
            )
          })}
      </Modal>
    </div>
  )
}
